/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CsrfToken } from '../model';
// @ts-ignore
import { IlmApiKey } from '../model';
/**
 * SecurityApi - axios parameter creator
 * @export
 */
export const SecurityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates/retrieves a CSRF token for the current session
         * @summary Initializes security, to be used by old Ilm
         * @param {IlmApiKey} ilmApiKey API Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init1: async (ilmApiKey: IlmApiKey, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ilmApiKey' is not null or undefined
            assertParamExists('init1', 'ilmApiKey', ilmApiKey)
            const localVarPath = `/security/init1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ilmApiKey, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates/retrieves a CSRF token for the current session
         * @summary Initializes security, to be used by Ilm next
         * @param {IlmApiKey} ilmApiKey API Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init2: async (ilmApiKey: IlmApiKey, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ilmApiKey' is not null or undefined
            assertParamExists('init2', 'ilmApiKey', ilmApiKey)
            const localVarPath = `/security/init2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ilmApiKey, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecurityApiAxiosParamCreator(configuration)
    return {
        /**
         * Generates/retrieves a CSRF token for the current session
         * @summary Initializes security, to be used by old Ilm
         * @param {IlmApiKey} ilmApiKey API Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async init1(ilmApiKey: IlmApiKey, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsrfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.init1(ilmApiKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generates/retrieves a CSRF token for the current session
         * @summary Initializes security, to be used by Ilm next
         * @param {IlmApiKey} ilmApiKey API Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async init2(ilmApiKey: IlmApiKey, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsrfToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.init2(ilmApiKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecurityApiFp(configuration)
    return {
        /**
         * Generates/retrieves a CSRF token for the current session
         * @summary Initializes security, to be used by old Ilm
         * @param {IlmApiKey} ilmApiKey API Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init1(ilmApiKey: IlmApiKey, options?: any): AxiosPromise<CsrfToken> {
            return localVarFp.init1(ilmApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates/retrieves a CSRF token for the current session
         * @summary Initializes security, to be used by Ilm next
         * @param {IlmApiKey} ilmApiKey API Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init2(ilmApiKey: IlmApiKey, options?: any): AxiosPromise<CsrfToken> {
            return localVarFp.init2(ilmApiKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecurityApi - object-oriented interface
 * @export
 * @class SecurityApi
 * @extends {BaseAPI}
 */
export class SecurityApi extends BaseAPI {
    /**
     * Generates/retrieves a CSRF token for the current session
     * @summary Initializes security, to be used by old Ilm
     * @param {IlmApiKey} ilmApiKey API Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public init1(ilmApiKey: IlmApiKey, options?: any) {
        return SecurityApiFp(this.configuration).init1(ilmApiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates/retrieves a CSRF token for the current session
     * @summary Initializes security, to be used by Ilm next
     * @param {IlmApiKey} ilmApiKey API Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public init2(ilmApiKey: IlmApiKey, options?: any) {
        return SecurityApiFp(this.configuration).init2(ilmApiKey, options).then((request) => request(this.axios, this.basePath));
    }
}
